module.exports = __webpack_public_path__ + "static/img/headerImg.6da99e36.png";